import React from 'react';
import Lottie from 'react-lottie';
import './No_Transaction_Matches_Lottie.css';
import * as animationData from './No_Transaction_Matches_Lottie.json';

function No_Transaction_Matches_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='No_Transaction_Matches_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default No_Transaction_Matches_Lottie;